import * as React from 'react';
import { colors } from '../../styles/colors';

interface IProps {
    text: string;
    isValid: boolean;
    style?: React.CSSProperties;
}

export class WarningText extends React.Component<IProps> {
    public render() {
        if (this.props.isValid) {
            return <div style={{ height: 15 }} />;
        }

        return <p style={{ color: colors.CANCEL_TEXT, ...this.props.style }}>{this.props.text}</p>;
    }
}



// WEBPACK FOOTER //
// ./src/Pages/AuthPages/WarningText.tsx